import { useEffect, useState } from 'react'
import { Box, Card, CardHeader, CardBody, Heading, Text, Spinner, VStack } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { EmailTemplateForm } from '@/components/forms/EmailTemplateForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditEmailTemplatePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const emailTemplateId = id ? Number(id) : undefined
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (!emailTemplateId || Number.isNaN(emailTemplateId)) {
      navigate('/system-settings/email-template', { replace: true })
    } else {
      setIsValidating(false)
    }
  }, [emailTemplateId, navigate])

  const handleSuccess = () => {
    navigate('/system-settings/email-template')
  }

  const handleCancel = () => {
    navigate('/system-settings/email-template')
  }

  if (isValidating || !emailTemplateId) {
    return (
      <AdminLayout>
        <Box p={4}>
          <Card>
            <CardBody>
              <VStack spacing={4} py={8}>
                <Spinner size="xl" color="blue.500" />
                <Text>Loading...</Text>
              </VStack>
            </CardBody>
          </Card>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit Email Template</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update email template information
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <EmailTemplateForm emailTemplateId={emailTemplateId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
